import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { store } from './store/store';
import { AppRoutes } from './router';
import FrontendVersionNotice from './components/common/FrontendVersionNotice';

function App() {
  return (
    <Provider store={store}>
      <ConfigProvider locale={zhCN}>
        <BrowserRouter
          future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true,
          }}
        >
          <AppRoutes />
          <FrontendVersionNotice />
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
